import {
  getCnvkitChromQc,
  getExomedepthPlots,
  getGlsCnvkitPlots
} from '@/@core/services/app.service'
import {
  Backdrop,
  Box,
  Button,
  ButtonGroup,
  CircularProgress,
  Stack
} from '@mui/material'
import { useRouter } from 'next/router'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'

interface Props {
  analysisInfo: any
  cnvSampleId?: any
}

const CnvKitQcPlot = React.forwardRef((props: Props, ref) => {
  const router = useRouter()
  const { t } = useTranslation()

  const { id } = router.query
  const plotlyRef = useRef<any>(null)
  const plotlyImgRef = useRef<any>(null)
  const cnvQcPlotRef = useRef<any>(null)
  const [plotlyImgSrc, setPlotlyImgSrc] = React.useState('')
  const [plotlyImgChrom, setPlotlyImgChrom] = React.useState('')

  const [cnvKitData, setCnvKitData] = React.useState<{
    plotAllData: string
    plotData: {
      chrom: string
      plot: string
    }[]
  }>({
    plotAllData: '',
    plotData: []
  })
  const [open, setOpen] = React.useState(false)

  const affectId = React.useMemo(() => {
    if (
      props.analysisInfo &&
      props.analysisInfo.samples &&
      Array.isArray(props.analysisInfo.samples)
    ) {
      const samples = props.analysisInfo.samples
      const affected_child = samples.find(
        (i: any) => i.type === 'affected_child'
      )
      if (affected_child) {
        return affected_child.id
      } else return id
    } else return id
  }, [props.analysisInfo])

  React.useEffect(() => {
    //

    setOpen(true)
    if (props.analysisInfo.pipelineVersion) {
      fetchExomedepthPlots.mutateAsync(props.cnvSampleId ?? affectId)
    } else fetchCnvChromPlot.mutateAsync(props.cnvSampleId ?? affectId)
  }, [affectId])

  const fetchCnvChromPlot = useMutation({
    mutationFn: async (id: string) => {
      return await getCnvkitChromQc(id)
    },
    onSuccess: (data) => {
      if (data) {
        setCnvKitData(data as any)
      }
    },
    onSettled: () => {
      setOpen(false)
    }
  })

  const fetchExomedepthPlots = useMutation({
    mutationFn: async (id: string) => {
      return await getGlsCnvkitPlots({
        id: id
      })
    },
    onSuccess: (data) => {
      if (data && data.plots) {
        setCnvKitData({
          plotAllData: '',
          plotData: data.plots.map((i: any) => {
            return {
              chrom: i.chromosome,
              plot: i.url
            }
          })
        })
      }
    },
    onSettled: () => {
      setOpen(false)
    }
  })

  const handleClose = () => {
    setOpen(false)
  }

  const maxHeight = React.useMemo(() => {
    const mains = document.getElementsByTagName('main')
    if (mains && Array.from(mains).length) {
      const main = Array.from(mains)[0]

      return main.clientHeight - 200
    } else return 800
  }, [])

  return (
    <Box
      sx={{
        overflow: 'auto',
        maxHeight: maxHeight
      }}
    >
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1
        }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box>
        {cnvKitData && cnvKitData.plotAllData ? (
          <Stack justifyContent={'center'}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img src={cnvKitData.plotAllData} />
            </Box>
          </Stack>
        ) : (
          ''
        )}

        {cnvKitData && cnvKitData.plotData && cnvKitData.plotData.length
          ? cnvKitData.plotData
              .filter((item) => item && item.plot)
              .map((items, index) => {
                return (
                  <Stack justifyContent={'center'}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <img key={items.chrom} src={items.plot} />
                    </Box>
                  </Stack>
                )
              })
          : ''}
      </Box>
    </Box>
  )
})

export default CnvKitQcPlot
